import QuestionObj from "../Models/QuestionObj";

const Sales_QSet = [
  new QuestionObj({
    questionSet: {
      English:
        "Does your ecommerce platform use AI and/or machine learning to offer recommended products and services based on customers’ buying habits?",
    },
    answerSet: {
      English: [
        "No",
        "Somewhat, we recommend additional offerings on our ecommerce site, but we do not use AI or engagement data to tailor offerings to our buyers",
        "Yes",
      ],
    },
    custVals: [25, 66, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "Can customers confidently explore your offerings, complete transitions, and manage their account information without speaking to a rep?",
    },
    answerSet: {
      English: [
        "No, our reps are an integral part in giving our customers the knowledge and information they need to make a purchase",
        "Somewhat, customers can view information on simple goods and offerings, but more complex purchases require rep assistance",
        "Yes, we provide robust information on all products and how they interact with each other to enable the buyer to have a completely self-service process",
      ],
    },
    custVals: [25, 66, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "Are you able to capture buying signals across channels to engage customers with the right offer in the moments that matter?",
    },
    answerSet: {
      English: [
        "No, our channels are siloed, so our sales team doesn’t have insight into customers’ digital engagement activity",
        "Somewhat, our sales team gains some insights into customers’ digital engagement, but it is limited and not real-time",
        "Yes, we can aggregate track all buying signals and engagement data, whether from direct interactions or digital methods, to better serve our customers wherever they choose to engage",
      ],
    },
    custVals: [25, 66, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "How much variability in pricing and catalogs can you support on your digital channels?",
    },
    answerSet: {
      English: [
        "None. Our digital channels offer static pricing for every account",
        "N/A – We do not sell B2B",
        "We are only able to offer some custom pricing and/or catalogs, but the majority must go through our direct sales channel",
        " We can fully customize our pricing and catalogs to reflect the negotiated terms with every individual account",
      ],
    },
    custVals: [25, 50,75, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "Does your commerce experience guide self-service buyers through complex purchases and product configurations?",
    },
    answerSet: {
      English: [
        "No, complex and configurable orders must be managed by our sales team",
         "We have some limited functionality when it comes to self-service goods and order purchasing, but it is not very intuitive, so customers tend to rely on our sellers for support",
         "Yes, we have robust functionality for configuration and pricing scenarios that our customers can confidently use on self-service channels"
        ],
    },
    custVals: [25,66, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "Can you support dynamic business models on self-service channels, providing customers tools to manage their own orders and accounts?",
    },
    answerSet: {
      English: [
        "No, we do not support recurring revenue models",
        "We offer recurring revenue models, but customers have limited access to their account, usage, and billing information on their own",
        "Yes, we support recurring revenue models and allow customers to easily access and manage their orders and accounts",
      ],
    },
    custVals: [25, 66, 100],
  }),
];

export default Sales_QSet;
